import moment from 'moment';

export const fullYear = () => (new Date()).getFullYear();

export const getHourOffSet = () => moment().utcOffset() / 60;

export const format = (dateStr, formatStr) => {
    let date = moment(dateStr);
    if (!date.isValid()) {
        return '';
    }

    return date.format(formatStr);
};
